import * as client from "../../client";

export const ORG_LABEL_MAP: Record<string, string> = {
  BROKER: "Brokerage",
};

export function getOrganizationLabel(
  contact: client.ReportContact | null
): string {
  if (!contact || !contact.contact_type) return "Organization";
  return ORG_LABEL_MAP[contact.contact_type.toUpperCase()] || "Organization";
}

export function getContactLabel(contact: client.ReportContact | null): string {
  if (!contact || !contact.contact_type) return "Contact";
  return (
    contact.contact_type.charAt(0).toUpperCase() + contact.contact_type.slice(1)
  );
}

export default { getOrganizationLabel, getContactLabel };
